import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import uuid from 'uuid';
import * as measure from '../../../utils/performance';
import { failUfoExperience, startUfoExperience, succeedUfoExperience } from '../../analytics';
var ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';

/**
 * Invoke client action such as preview, download and open link
 */
var useInvokeClientAction = function useInvokeClientAction(_ref) {
  var analytics = _ref.analytics;
  return useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var actionType, actionFn, extensionKey, display, experienceId, markName, result, reason;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            actionType = _ref2.actionType, actionFn = _ref2.actionFn, extensionKey = _ref2.extensionKey, display = _ref2.display;
            experienceId = uuid(); // Begin performance instrumentation.
            markName = "".concat(experienceId, "-").concat(actionType);
            measure.mark(markName, 'pending');
            _context.prev = 4;
            // Begin UFO experience
            startUfoExperience(ACTION_EXPERIENCE_NAME, experienceId, {
              actionType: actionType,
              display: display,
              extensionKey: extensionKey,
              invokeType: 'client'
            });

            // Begin analytics instrumentation.
            analytics === null || analytics === void 0 || analytics.ui.actionClickedEvent({
              actionType: actionType,
              display: display
            });

            // Invoke action
            _context.next = 9;
            return actionFn();
          case 9:
            result = _context.sent;
            measure.mark(markName, 'resolved');
            succeedUfoExperience(ACTION_EXPERIENCE_NAME, experienceId);
            analytics === null || analytics === void 0 || analytics.operational.invokeSucceededEvent({
              actionType: actionType,
              display: display
            });
            return _context.abrupt("return", result);
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](4);
            measure.mark(markName, 'errored');
            failUfoExperience(ACTION_EXPERIENCE_NAME, experienceId);
            reason = typeof _context.t0 === 'string' ? _context.t0 : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message;
            analytics === null || analytics === void 0 || analytics.operational.invokeFailedEvent({
              actionType: actionType,
              display: display,
              reason: reason
            });
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 16]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [analytics === null || analytics === void 0 ? void 0 : analytics.operational, analytics === null || analytics === void 0 ? void 0 : analytics.ui]);
};
export default useInvokeClientAction;